import React from 'react'
import PropTypes from 'prop-types'
import { Chip as MuiChip, Tooltip } from '@mui/material'
import { getTextColorByHexColor } from 'common/utils/ColorUtil'

const Chip = ({
    label = '',
    color = '',
    tooltip,
    onClick,
    sx = {},
}) => {
    if (tooltip) {
        return (
            <Tooltip title={tooltip}>
                <MuiChip size='small' label={label} onClick={onClick} sx={{ backgroundColor: color, color: getTextColorByHexColor(color), fontSize: '16px', ...sx }} />
            </Tooltip>
        )
    }
    return (
        <MuiChip size='small' label={label} onClick={onClick} sx={{ backgroundColor: color, color: getTextColorByHexColor(color), fontSize: '16px', ...sx }} />
    )
}

Chip.propTypes = {
    label: PropTypes.node,
    color: PropTypes.string,
    tooltip: PropTypes.string,
    onClick: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),
    sx: PropTypes.shape({}),
}

export default Chip